const insuranceRelationToInsured = [
  'Self',
  'Spouse',
  'Child',
  'Employee',
  'Unknown',
  'Organ Donor',
  'Cadaver Donor',
  'Life Partner',
  'Other',
];

export const insuranceRelationToInsuredWorkersCompAuto = [
  'Self',
  'Employee',
];

export default insuranceRelationToInsured;



// WEBPACK FOOTER //
// ./src/config/insuranceRelationToInsured.js